export default __webpack_public_path__ + "f780bddf026ba0f748f2e2fd223fdbf3.svg";